import { useTranslation } from '@crehana/i18n';
import { ATS_CAREER_SITE_ADMIN_SHARED } from './constants';
import type { TKeys } from './types';

export const useTranslationCareerSiteAdminShared = () => {
  return useTranslation<TKeys>(ATS_CAREER_SITE_ADMIN_SHARED);
};
